/**
 * `/tools/drift-accumulation/...` → `/drew/...` (Beta-1 plan P6-14). Keeps e-mails, tours,
 * bookmarks and n8n links working after DREW's routes moved. Query string and hash survive.
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const LEGACY = '/tools/drift-accumulation';

export function legacyToDrew(pathname, search = '', hash = '') {
  const rest = String(pathname || '').startsWith(LEGACY) ? pathname.slice(LEGACY.length) : '';
  return `/drew${rest}${search || ''}${hash || ''}`;
}

export default function LegacyDrewRedirect() {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={legacyToDrew(pathname, search, hash)} replace />;
}
